import { Link, useBreakpointValue, useChakraContext } from '@chakra-ui/react';

import { Image } from '@nocowanie/common-ui/components/atoms/image';

import { SectionNameEnum } from '@app/enums';
import { HorizontalBanner as HorizontalBannerModel } from '@app/models/cms-api';
import * as cmsHomepageSlice from '@app/state/slices/cms-homepage';
import { useAppSelector } from '@app/state/state';

export const HorizontalBanner = () => {
    const horizontalBannerData = useAppSelector(
        cmsHomepageSlice.selectors.selectSectionData<HorizontalBannerModel>(
            SectionNameEnum.HorizontalBanner,
        ),
    );

    const theme = useChakraContext();
    const md = theme.breakpoints.values.find(b => b.name === 'md')?.min;

    const fetchPiority = useBreakpointValue(
        {
            base: 'auto',
            md: 'high',
        },
        {},
    );

    if (!horizontalBannerData) return;

    const {
        altText,
        image: { imageLg, imageSm },
        url,
    } = horizontalBannerData;

    return (
        <Link href={url} data-testid={'horizontal-banner'} display={'block'} my={-4}>
            <Image
                src={imageSm.url}
                htmlWidth={imageSm.width}
                htmlHeight={imageSm.height}
                alt={altText || ''}
                w={'full'}
                borderRadius={'tile'}
                sources={[
                    {
                        srcSet: imageLg.url,
                        media: `(min-width: ${md})`,
                        width: imageLg.width,
                        height: imageLg.height,
                    },
                ]}
                fetchpriority={fetchPiority}
            />
        </Link>
    );
};
